<template>
  <div class="inner-content">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'InnerContent',
};
</script>

<style lang="scss" scoped>
  .inner-content {
    width: 100%;
    max-width: 1024px;
    margin: 0 auto;
    padding: 0 rem(25px);
    position: relative;
  }
</style>
